// extracted by mini-css-extract-plugin
export default {"container":"AdvertisingDisclosure_container__QshpJ"};